export default function getCurrentEnrollment(subscription) {
  return subscription.prepEnrollment || subscription.schoolEnrollment || {}
}
